import { ReactNode } from "react";
import { Helmet } from "react-helmet";

import { color } from "minimum-ui/tokens";
// import { AnalyticsContext } from "Tracking/AnalyticsProvider";
import styled from "styled-components";

export type PageProps = {
  className?: string;
  children?: ReactNode;
  name: string;
  tabName?: string;
};

const Page: React.FC<PageProps> = ({ children, className, name, tabName }) => {
  return (
    <Container className={className}>
      <Helmet title={tabName ?? name} />
      {children}
    </Container>
  );
};

const Container = styled.div`
  padding: 24px 48px 32px;
  background-color: ${color.basic.white};
  overflow: visible;
  min-height: 100%;
`;

export default Page;
